module.exports = __webpack_public_path__ + "static/media/schoolmarket-logo.d68534a7.png";